import React from 'react';
import './KrabbyPattyFormula.css';

function KrabbyPattyFormula() {
  return (
    <div className="krabby-formula-container">
      <div className="content">
        <h1>ART THROUGH MOVEMENT.</h1>
        <h2>LEARNING TO FLOW WITH STRIKING AND MUSIC.</h2>
        <h3>MUAY THAI BEATS INC.</h3>
      </div>
    </div>
  );
}

export default KrabbyPattyFormula; 